import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { fetchWithError } from "../utils/fetchWithError.ts";
import CircularProgress from "@mui/material/CircularProgress";
import Box from "@mui/material/Box";

/**
 * Component that redirects based on authentication status:
 * - If logged in: redirects to /app/profile
 * - If not logged in: redirects to /app/login
 */
export const AppRedirect = () => {
    const [checking, setChecking] = useState(true);
    const navigate = useNavigate();

    useEffect(() => {
        fetchWithError("/session", { credentials: "include" })
            .then((result) => {
                if (result.session) {
                    // User is logged in, redirect to profile
                    navigate("/app/profile", { replace: true });
                } else {
                    // User is not logged in, redirect to login
                    navigate("/app/login", { replace: true });
                }
            })
            .catch(() => {
                // On error, assume not logged in and redirect to login
                navigate("/app/login", { replace: true });
            })
            .finally(() => {
                setChecking(false);
            });
    }, [navigate]);

    // Show loading indicator while checking authentication
    if (checking) {
        return (
            <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", minHeight: "100vh" }}>
                <CircularProgress />
            </Box>
        );
    }
    
    // This should not be reached as navigation happens in useEffect
    return null;
};

